import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import router from '@/router'

// 创建 axios 接口
let service = axios.create({
  baseURL: process.env.VUE_APP_PHP_API,
  timeout: 10000,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'os': '2'
  }
})

// request拦截器
service.interceptors.request.use(config => {
  if (!router.history.current.meta.notToken) {
    config.headers['token'] = store.getters.token || '' //f5043d03aa81f3f8145d2888dd5b82564172e949
  }
  // 社区列表
  config.data = qs.stringify(config.data)
  return config
}, error => {
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(response => {
  let res = response.data
  if (res.code == 200) {
    return res
  } else {
    // 判断登录过期 重定向登录页面
    if (res.code == 100) {
      if (res.msg == '您的用户信息已经过期，请重新登录') {
        return Promise.reject('401')
      }
    }
  }
  return Promise.reject(res.msg)
}, error => {
  return Promise.reject(error)
})

/**
 * @description: post请求
 * @param {type}
 * @return: promise
 */
 export function php_post(url, data = {}) {
  return new Promise((resolve, reject) => {
    service.post(url, data)
      .then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
  })
}
